var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m22.673 17.009-2.452-2.453a2.811 2.811 0 0 0-3.979 0l-.5.5A54.366 54.366 0 0 1 8.94 8.245l.5-.5a2.817 2.817 0 0 0 0-3.978l-2.457-2.45a2.883 2.883 0 0 0-3.983 0L1.66 2.663a3.981 3.981 0 0 0-.5 4.994 54.174 54.174 0 0 0 15.173 15.176 4.015 4.015 0 0 0 5-.5l1.345-1.346a2.809 2.809 0 0 0 0-3.977Z"
})));
export default SvgPhone;